import React from 'react';
import { connect } from 'react-redux';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Move, X, Pencil } from 'lucide-react';
import { Button } from '../ui/button';
import { MetricCard, MetricLabel, MetricValue, MetricDelta } from '../ui/metric-card';

const DashboardCard = ({
  title,
  value,
  unit,
  delta,
  sublabel,
  accent = 'success',
  userAdded,
  id,
  setDashboardModal,
  editing,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = { transition, transform: CSS.Transform.toString(transform) };

  return (
    <MetricCard
      accent={accent}
      className={'dashboard-card-metric relative rounded-xl border-border' + (userAdded ? ' pb-10' : '')}>
      {editing && (
        <div className="chart-move" style={style} ref={setNodeRef} {...attributes} {...listeners}>
          <Move size={16} strokeWidth={1.5} className="move-icon" title="Move Chart" />
        </div>
      )}
      {userAdded && (
        <div className="absolute right-0 top-0 z-10 flex">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-muted-foreground hover:text-foreground"
            onClick={() => setDashboardModal({ show: true, id, action: 'delete' })}>
            <X size={15} strokeWidth={1.5} title="Delete Component" />
          </Button>
        </div>
      )}
      <div className="flex flex-1 flex-col items-center text-center pt-1 min-h-0">
        <MetricLabel className="text-muted-foreground">{title}</MetricLabel>
        <div className="flex flex-1 flex-col items-center justify-center w-full">
          <MetricValue className="text-2xl md:text-3xl font-display font-bold text-foreground">
            {value}
          </MetricValue>
          {sublabel && (
            <span className="text-sm text-muted-foreground mt-1">{sublabel}</span>
          )}
          {delta != null && (
            <div className="mt-2 flex justify-center">
              {delta}
            </div>
          )}
          {unit != null && typeof unit === 'string' && !sublabel && !delta && (
            <span className="text-sm text-muted-foreground mt-1">{unit}</span>
          )}
          {unit != null && typeof unit !== 'string' && !delta && !sublabel && (
            <div className="mt-2 flex justify-center">{unit}</div>
          )}
        </div>
      </div>
      <div className="mt-auto pt-3 border-t border-border" />
      {userAdded && (
        <div className="absolute right-0 bottom-0 flex">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-muted-foreground hover:text-foreground"
            onClick={() => setDashboardModal({ show: true, id })}>
            <Pencil size={15} strokeWidth={1.5} title="Edit Component" />
          </Button>
        </div>
      )}
    </MetricCard>
  );
};

export default connect()(DashboardCard);
